module.exports = __webpack_public_path__ + "img/Download-Upload.f5ff7207.png";